export const SORT_EVENT_MAP = {
  size: 'size',
  filename: 'filename',
  extension: 'extension',
  time: 'time',
} as const
export type TriggerSortKeys = keyof typeof SORT_EVENT_MAP;

export const triggerSortEvent = (key: TriggerSortKeys, eventType = 'click') => {
  const elm = document.querySelector(`th[data-id="${key}"]`)
  if (!elm) { return null; }
  // since we will lose focus, stash-it, and return if re-focus logic needed
  const prvFocusElm = document.activeElement as HTMLElement | null;
  elm.dispatchEvent(new CustomEvent(eventType));
  window.dispatchEvent(new CustomEvent('quaint.resort'));
  return prvFocusElm;
}
